import { Box, Stack, Typography } from '@mui/material'

const logoSrc = `${import.meta.env.BASE_URL}eirsolutions-logo.png`

type PortalBrandProps = {
  compact?: boolean
  center?: boolean
  stacked?: boolean
  showTitle?: boolean
}

export function PortalBrand({
  compact = false,
  center = false,
  stacked = false,
  showTitle = true,
}: PortalBrandProps) {
  return (
    <Stack
      direction={stacked ? 'column' : 'row'}
      spacing={stacked ? 0.75 : compact ? 1 : 1.5}
      alignItems="center"
      justifyContent={center ? 'center' : 'flex-start'}
      sx={{ minWidth: 0 }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="Eir Solutions"
        sx={{
          display: 'block',
          height: compact ? { xs: 36, sm: 42 } : { xs: 56, sm: 68 },
          width: 'auto',
          maxWidth: compact ? { xs: 136, sm: 160 } : { xs: 190, sm: 230 },
          objectFit: 'contain',
          flexShrink: 0,
        }}
      />
      {showTitle && (
        <Typography
          variant={compact ? 'subtitle1' : 'h5'}
          sx={{
            fontWeight: 700,
            lineHeight: 1.15,
            whiteSpace: 'nowrap',
            minWidth: 0,
            textAlign: stacked || center ? 'center' : 'left',
          }}
        >
          Legevakt Portal
        </Typography>
      )}
    </Stack>
  )
}
